import React from 'react'
import { AddressElement } from '@stripe/react-stripe-js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import RadioList from 'src/components/RadioList'

const Form = ({
  handleSubmit, sendTo, setSendTo, customAddress, setCustomAddress, theFamilyOf,
  providedAddress, config, loading,
}) => (
  <form noValidate onSubmit={handleSubmit}>
    <p>
      Order today and your condolence below will be printed in this
      card and mailed to the family on the next business day.
    </p>

    {
      providedAddress
    ? <div className="fs-5">
        <RadioList
          id="sympathyCardSendTo"
          name="sympathyCardSendTo"
          options={[
            {
              label: config.providedLabel,
              value: 'provided',
              hint: sendTo == 'provided' &&
              <div className="fs-6 mb-3 text-body">
                {theFamilyOf}<br />
                {config.showCareOf && <>{`c/o ${providedAddress.name}`}<br /></>}
                {providedAddress.address.line1}<br />
                {providedAddress.address.line2}{providedAddress.address.line2 && <br />}
                {providedAddress.address.city}, {providedAddress.address.state} {providedAddress.address.postal_code}
              </div>
            },
            {
              label: config.customLabel,
              value: 'custom'
            },
          ]}
          value={sendTo}
          onChange={e => setSendTo(e.target.value)}
        />
      </div>
    : <h6 className="h5">Family Address</h6>
    }

    {
      sendTo == 'custom' &&
      <div className="mb-3">
        <AddressElement
          options={{
            mode: 'shipping',
            // A Stripe bug causes the React app to crash when
            // PaymentRequestButton unmounts on the previous page
            // if autocomplete is enabled.

            // autocomplete: {
            //   mode: 'google_maps_api',
            //   apiKey: googleApiKey,
            // },
            allowedCountries: [ 'US' ],
            defaultValues: {
              name: theFamilyOf,
              ...customAddress,
            },
            fields: { phone: 'never' },
          }}
          onChange={({ value }) => setCustomAddress(value)}
        />
      </div>
    }

    <div className="d-grid">
      <button className="btn btn-primary" disabled={loading}>
        {
          loading &&
          <FontAwesomeIcon icon={faCircleNotch} spin className="me-2" />
        }
        Next — Confirmation
      </button>
    </div>
  </form>
)

export default Form
